<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'admin.deleteUser.title' | translate }}
    </h5>
    <button type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body">
    @if (error) {
      <div class="alert alert-danger mb-3">
        {{ 'admin.deleteUser.error' | translate }}
      </div>
    }

    <p>{{ 'admin.deleteUser.message' | translate: { userName: user.name } }}</p>

    <label class="form-label" for="delete-user-confirmation">
      {{ 'admin.deleteUser.confirmLabel' | translate: { emailAddress: user.emailAddress } }}
    </label>
    <input id="delete-user-confirmation"
      type="text"
      class="form-control"
      autocomplete="off"
      [placeholder]="user.emailAddress"
      [(ngModel)]="confirmationEmail"
      (keyup.enter)="confirmDeletion()"
    />
  </div>

  <div class="modal-footer">
    <button id="btn-cancel-delete-user"
      class="btn btn-link link-secondary"
      (click)="cancel()">
      {{ 'cancel' | translate }}
    </button>

    <button id="btn-submit-delete-user"
      class="btn btn-danger ms-auto"
      [disabled]="!confirmed || submitting"
      (click)="confirmDeletion()"
      >
      @if (!submitting) {
        <span>{{ 'admin.deleteUser.submit' | translate }}</span>
      }
      @if (submitting) {
        <span class="spinner-border spinner-border-sm" role="status"></span>
      }
    </button>
  </div>
</div>
